import { ACTION_PLAN_STATE_SLICE_KEY } from './constants';
import { goodEnoughUUID } from '../../../../utils/uuid';

export const initialState = {
  actionReportStateRefreshUuid: goodEnoughUUID(), // simple uuid, just used to flag when state has been modified by data returned from the backend.
	isFetchingActionPlanState: false,
	isActionPlanStateLoaded: false,
	[ACTION_PLAN_STATE_SLICE_KEY]: {},
	// @todo - these should be tracked from within the actionPlanState object
	actionReportThreshold: -850,
	actionReportUseShadow: true,
	actionReportCustomGroups: []
};

export default initialState;
